import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

export default (maxUploadSize) => {
  const { t } = useTranslation('labels');
  const [attachments, setAttachments] = useState([]);

  const attachFile = (files) => {
    if (files.length) {
      const newFileList = [...attachments, ...files];
      const filesSize = newFileList.reduce((acc, { size }) => acc + size, 0);
      if (filesSize > maxUploadSize) {
        toast.error(() => (
          <div>
            {t('file_size_limit_exceeded')}
            <Typography variant="caption" component="p">
              {t('total_size_of_attachments_must_be_less_than_20MB')}
            </Typography>
          </div>
        ));
        return;
      }
      setAttachments(newFileList);
    }
  };

  const deleteFile = (i) => () => setAttachments(attachments.filter((_, fileIndex) => i !== fileIndex));
  const clearAttachments = () => setAttachments([]);
  return { attachments, attachFile, deleteFile, clearAttachments };
};
